import { IUserAuth } from "../types/user/UserAuth";

export const isAdmin = (user: IUserAuth | null): boolean => {
  return user?.scope?.customer === "*";
};
